import { Component } from '@angular/core';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import { Project } from '@src/app/models/project';
import { SessionHelper } from '@src/app/helpers/sessionHelper';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-durationchart',
  templateUrl: './durationchart.component.html',
  styleUrls: ['./durationchart.component.css']
})
export class DurationchartComponent {
  private root!: am5.Root;
  projects:Project[];

  ngAfterViewInit(){
    let root = am5.Root.new("chartdiv1");
    root.setThemes([
      am5themes_Animated.new(root)
    ]);
    // Create chart
// https://www.amcharts.com/docs/v5/charts/xy-chart/
let chart = root.container.children.push(am5xy.XYChart.new(root, {
  panX: true,
  panY: true,
  wheelX: "none",
  wheelY: "none"
}));

// We don't want zoom-out button to appear while animating, so we hide it
chart.zoomOutButton.set("forceHidden", true);


// Create axes
// https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
let xRenderer = am5xy.AxisRendererX.new(root, {
  minGridDistance: 30,
});

xRenderer.labels.template.setAll({
  rotation: 0,
  centerY: am5.p50,
  centerX: 0,
  fontSize: 10,
  paddingRight: 15
});
xRenderer.grid.template.set("visible", false);

let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
  maxDeviation: 0.3,
  categoryField: "country",
  renderer: xRenderer,
}));

let yRenderer = am5xy.AxisRendererY.new(root, {
  minGridDistance: 30,
});

yRenderer.labels.template.setAll({
  rotation: 0,
  centerY: 0,
  centerX: 0,
  fontSize: 10,
  paddingRight: 0
});
yRenderer.grid.template.set("visible", false);

let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
  maxDeviation: 0.3,
  min: 0,
  renderer: yRenderer,
}));

// Add series
// https://www.amcharts.com/docs/v5/charts/xy-chart/series/
let series = chart.series.push(am5xy.ColumnSeries.new(root, {
  name: "Series 1",
  xAxis: xAxis,
  yAxis: yAxis,
  valueYField: "value",
  categoryXField: "country",
}));

// Rounded corners for columns
series.columns.template.setAll({
  cornerRadiusTL: 5,
  cornerRadiusTR: 5,
  strokeOpacity: 0,
});

// Make each column to be of a different color
series.columns.template.adapters.add("fill", function (fill, target) {
  return chart.get("colors").getIndex(series.columns.indexOf(target ));
});

series.columns.template.adapters.add("stroke", function (stroke, target) {
  return chart.get("colors").getIndex(series.columns.indexOf(target ));
});

// Add Label bullet
series.bullets.push(function () {
  return am5.Bullet.new(root, {
    locationY: 1,
    sprite: am5.Label.new(root, {
      text: "{valueYWorking.formatNumber('#.')}",
      fill: root.interfaceColors.get("alternativeText"),
      centerY: 0,
      centerX: am5.p50,
      populateText: true,
      fontSize: 10,
    })
  });
});


this.projects = JSON.parse(SessionHelper.getPortalProjectList());

var first_quarter = 0;
var first_sum = 0;
var second_quarter = 0;
var second_sum = 0;
var third_quarter = 0;
var third_sum = 0;
var fourth_quarter = 0;
var fourth_sum = 0;
this.projects.filter(p => p.progress == 100).forEach(proj => {
  //check if the project ended within the last year
  var today = new Date();
  var lastyear = new Date();
  lastyear.setFullYear(today.getFullYear() - 1);
  if(new Date(proj.end_date) > lastyear){
//Calculate the avage duration of projects in each quarter
var quarter = new Date(proj.end_date).getMonth();
if(quarter >= 0 && quarter <= 2){
  first_quarter++;
  first_sum += (new Date(proj.end_date).getTime() - new Date(proj.start_date).getTime()) / (1000 * 3600 * 24);
}else if(quarter >= 3 && quarter <= 5){
  second_quarter++;
  second_sum += (new Date(proj.end_date).getTime() - new Date(proj.start_date).getTime()) / (1000 * 3600 * 24);
}else if(quarter >= 6 && quarter <= 8){
  third_quarter++;
  third_sum += (new Date(proj.end_date).getTime() - new Date(proj.start_date).getTime()) / (1000 * 3600 * 24);
}else{
  fourth_quarter++;
  fourth_sum += (new Date(proj.end_date).getTime() - new Date(proj.start_date).getTime()) / (1000 * 3600 * 24);
}
};//end if

});


let data = [{
  "country": "Q1",
  "value": first_sum / first_quarter
}, {
  "country": "Q2",
  "value": second_sum / second_quarter
}, {
  "country": "Q3",
  "value": third_sum / third_quarter
}, {
  "country": "Q4",
  "value":  fourth_sum / fourth_quarter
}];

xAxis.data.setAll(data);
series.data.setAll(data);

// // update data with random values each 1.5 sec
// setInterval(function () {
//   updateData();
// }, 1500)

function updateData() {
  am5.array.each(series.dataItems, function (dataItem) {
    let value = dataItem.get("valueY") + Math.round(Math.random() * 300 - 150);
    if (value < 0) {
      value = 10;
    }
    // both valueY and workingValueY should be changed, we only animate workingValueY
    dataItem.set("valueY", value);
    dataItem.animate({
      key: "valueYWorking",
      to: value,
      duration: 600,
      easing: am5.ease.out(am5.ease.cubic)
    });
  })

  sortCategoryAxis();
}


// Get series item by category
function getSeriesItem(category) {
  for (var i = 0; i < series.dataItems.length; i++) {
    let dataItem = series.dataItems[i];
    if (dataItem.get("categoryX") == category) {
      return dataItem;
    }
  }
}


// Axis sorting
function sortCategoryAxis() {

  // Sort by value
  series.dataItems.sort(function (x, y) {
    return y.get("valueY") - x.get("valueY"); // descending
    //return y.get("valueY") - x.get("valueY"); // ascending
  })

  // Go through each axis item
  am5.array.each(xAxis.dataItems, function (dataItem) {
    // get corresponding series item
    let seriesDataItem = getSeriesItem(dataItem.get("category"));

    if (seriesDataItem) {
      // get index of series data item
      let index = series.dataItems.indexOf(seriesDataItem);
      // calculate delta position
      let deltaPosition = (index - dataItem.get("index", 0)) / series.dataItems.length;
      // set index to be the same as series data item index
      dataItem.set("index", index);
      // set deltaPosition instanlty
      dataItem.set("deltaPosition", -deltaPosition);
      // animate delta position to 0
      dataItem.animate({
        key: "deltaPosition",
        to: 0,
        duration: 1000,
        easing: am5.ease.out(am5.ease.cubic)
      })
    }
  });

  // Sort axis items by index.
  // This changes the order instantly, but as deltaPosition is set,
  // they keep in the same places and then animate to true positions.
  xAxis.dataItems.sort(function (x, y) {
    return x.get("index") - y.get("index");
  });
}


// Make stuff animate on load
// https://www.amcharts.com/docs/v5/concepts/animations/
series.appear(1000);
chart.appear(1000, 100);

  }

}
